let dev = 'https://dev.rentamania.es'; // для возможности в рантайме менять переменную для экспорта переменной


export const BASE_URL = process.env.NODE_ENV === 'production' ?
    (process.env.REACT_APP_ENV === 'production' ?
            getCurrentProduction() :       // prod-staging
            dev     // dev-staging
    ) : 'http://localhost:20010';                // local-dev-staging

console.log('NODE_ENV: ' + process.env.NODE_ENV);
console.log('REACT_APP_ENV: ' + process.env.REACT_APP_ENV);
console.log('BASE_URL: ' + BASE_URL);

export const HEADER_AUTH_TOKEN = 'Authorization';

export const FACEBOOK_LOGIN_URL = BASE_URL + '/rest/api/jwt/auth/facebook/login';

/* IMGS */
export const BASE_IMG_URL = BASE_URL + '/files/img';
export const BASE_USER_AVATAR_URL = BASE_URL + '/files/users';


function getCurrentProduction() {
    let currentHref = window.location.href.toString();

    if (currentHref.indexOf("https://rentamania") !== -1) {
        return "https://rentamania.es";
    }

    if (currentHref.indexOf("https://es.rentamania") !== -1) {
        return "https://rentamania.es";
    }

    if (currentHref.indexOf("https://en.rentamania") !== -1) {
        return "https://en.rentamania.es";
    }

    if (currentHref.indexOf("https://ru.rentamania") !== -1) {
        return "https://ru.rentamania.es";
    }

    if(currentHref.indexOf("https://dev.rentamania") != -1){
        return "https://dev.rentamania.es";
    }

    return currentHref;
}



// WEBPACK FOOTER //
// ./src/constants/Api.js